<template>
    <div class="body" >
        <div class="t-img"> 
            <img src="@/assets/hd/95.png" alt="">
        </div>
        <div class="huodong">
            <div class="hd-flex">
                <div class="huodongTitle">
                    <img src="@/assets/hd/down.png" alt="">
                    <div class="huodongTitleText">可叠加活动券</div>
                </div>
                <div class="title">
                    <div class="text1">充60元得70元</div>
                    <div class="uniui-circle">
                         <van-checkbox  v-model="checked60"  @change="checkChange60" @click="isChange60"></van-checkbox> 
                    </div>
                </div>
                <div class="text3">充值60元余额，额外赠送1张10元电子券</div>
                <div class="s-img">
                    <img src="@/assets/hd/e6.png" alt="">
                </div>
                <div class="text4">充值60元余额，额外赠送1张10元电子券，可与其他电子券同时使用</div>
            </div>

            <div class="hd-flex">
                <div class="huodongTitle">
                    <img src="@/assets/hd/down.png" alt="">
                    <div class="huodongTitleText">可叠加活动券</div>
                </div>
                <div class="title">
                    <div class="text1">充100元得120元</div>
                    <div class="uniui-circle">
                         <van-checkbox  v-model="checked100"  @change="checkChange100" @click="isChange100"></van-checkbox> 
                    </div>
                </div>
                <div class="text3">充值100元余额，额外赠送2张10元电子券</div>
                <div class="s-img">
                    <img src="@/assets/hd/69.png" alt="">
                </div>
                <div class="text4">充值100元余额，额外赠送2张10元电子券，可与其他电子券同时使用</div>
            </div>

            <div class="hd-flex">
                <div class="huodongTitle">
                    <img src="@/assets/hd/down.png" alt="">
                    <div class="huodongTitleText">可叠加活动券</div>
                </div>
                <div class="title">
                    <div class="text1">充200元得250元</div>
                    <div class="uniui-circle">
                        <van-checkbox  v-model="checked200"  @change="checkChange200" @click="isChange200"></van-checkbox> 
                    </div>
                </div>
                <div class="text3">充值200元余额，额外赠送5张10元电子券</div>
                <div class="s-img">
                    <img src="@/assets/hd/ad.png" alt="">
                </div>
                <div class="text4">充值200元余额，额外赠送5张10元电子券，可与其他电子券同时使用</div>
            </div>
            <div class="checkbox-info">
                <van-checkbox v-model="checked"></van-checkbox> <span style="color:#fff;cursor: pointer;" @click="aaaa()">我已阅读并且同意</span><span @click="cccc()" style="color:#ffff00;cursor: pointer;">活动协议</span>
            </div>
             <mt-button type="primary" size="large" class="huodongBtn" @click="paymentSubmit()">立即支付</mt-button> 
        </div>
        <!-- 密码框   -->
	    <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
        <div class="van-popup van-popup--round van-popup--center changePasswordPanel-balanceRecharge" 
            style="z-index: 2000; min-height: 25%; min-width: 80%;"
            v-show="showPasswordPanel"
            :style="{top:passwordPanelTop+'%'}"
        >   
            <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()"/>
            <!-- 密码输入框 -->
            <p>设置支付密码：</p>
            <van-password-input :value="password" :focused="passwordKeyboard" @focus="passwordOnfocus()" />

            <!-- 再次确认密码输入框 -->
            <p>再次确认密码：</p>
            <van-password-input :value="confirmPassword" :focused="confirmPasswordKeyboard" @focus="confirmPasswordOnfocus()" />
            <div class="confirmChangePassword">
                <van-button class="confirmChangePasswordBtn" plain hairline  type="info" @click="sureToRecharge()">确 定</van-button>
            </div>
        </div>
        <!-- 数字键盘 -->
        <van-number-keyboard :z-index="2015" :show="passwordKeyboard" @input="passwordOnInput" @delete="passwordOnDelete"  @blur="passwordKeyboard = false" />
        <van-number-keyboard :z-index="2015" :show="confirmPasswordKeyboard"  @input="confirmPasswordOnInput"  @delete="confirmPasswordOnDelete"  @blur="confirmPasswordKeyboard = false" />
    </div>
</template>
<script>
import { Dialog,Toast } from 'vant';
import { wxRequest } from '@/api/user.js'
export default {
    data(){
        return {
            checked:false,
            checked60:false,
            checked100:false,
            checked200:false,
            confirmPassword:'',
            type:'',
            showPasswordPanel: false,
		    password:'',
            payPrice:0,
            amount:0,
	      	passwordKeyboard : false,
	      	confirmPasswordKeyboard : false,
	      	passwordPanelTop: 50,
		    alreadySetUp: false,
            isWx: false,
        }
    },
    created(){
        //判断是不是在微信环境中
        var ua = window.navigator.userAgent.toLowerCase();
        //通过正则表达式匹配ua中是否含有MicroMessenger字符串
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            this.isWx = true;
        }
    },
    methods:{
        checkChange60(event){
            this.checked60 = event
            if(event){
                this.amount = 60 * 10 * 10
                this.payPrice = 60 * 10 * 10
            }
        },
        checkChange100(event){
            this.checked100 = event
            if(event){
                this.amount = 100 * 10 * 10
                this.payPrice = 100 * 10 * 10
            }
        },
        checkChange200(event){
            this.checked200 = event
            if(event){
                this.amount = 200 * 10 * 10
                this.payPrice = 200 * 10 * 10
            }
        },
        isChange200(){
            this.checked60 = false
            this.checked100 = false
        },
        isChange100(){
            this.checked60 = false
            this.checked200 = false
        },
        isChange60(){
            this.checked100 = false
            this.checked200 = false
        },
        //立即支付
        paymentSubmit(){
            if(!this.checked){
                Toast.fail("请同意活动协议");
                return
            }
            if(!this.checked60 && !this.checked100 && !this.checked200){
                Toast.fail("请选择活动");
                return
            }
            this.isAccount()
        },
        submitEvent(){
            var data = { 
                iccid: this.$store.state.iccid,//iccid
                amount: this.amount, //用户选择的金额 //单位分
                giftBalance:0,//固定值
                payPass: this.confirmPassword, //用户没有开户时 输入的密码
                payType: 20,//固定值
                isSale:1, //固定值
                payPrice: this.payPrice, //用户选择的金额 //单位分
            }
            wxRequest("order/user/create/investOrder", data, "post").then(res => {
                if(res.data.code === '200'){
                    if (data.payType == 20) {//微信第三方
                        if (this.isWx) {
                            var param = res.data.data.param;
                            if (typeof WeixinJSBridge == "undefined") {
                                if (document.addEventListener) {
                                    document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                                    document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                                }
                            } else {
                                this.onBridgeReady(param);
                            }
                        } else {
                            window.location.href = res.data.data.mweb_url;
                        }
                    }
                }else{
                    Toast.fail({message: res.data.message});
                } 
            });
        },
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke('getBrandWCPayRequest', param,
                function (res) {
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        _this.$router.push({
                            path: '/newUser/home',
                            query: { iccid: _this.$store.state.iccid }
                        }).catch(() => {

                        });
                    }
                }
            );
        },
        //判断当前用户是否开户
        isAccount(){
            const param = {
                iccid: this.$store.state.iccid,
                mobile: localStorage.getItem('mobile')
            }
            this.confirmPassword = ''
            wxRequest("sysUser/account/querySysUserAccount", param, "post").then(res => {
                console.log(res.data)
                if(res.data.code != 200){
                    //code=200 表示已开户     
                    this.showPasswordPanel = true;
                }else{
                    this.alreadySetUp = true
                    this.submitEvent()
                }
            });
        },
        /***   修改密码     ***/
	    passwordOnfocus(){
	        this.passwordKeyboard = true;
	        this.confirmPasswordKeyboard = false;
	        this.passwordPanelTop = 30;
	    },
	    passwordOnDelete() {
	      this.password = this.password.slice(0, this.password.length - 1);
	    },
	    passwordOnInput(key) {
	        this.password = (this.password + key).slice(0, 6);
	    },
	    confirmPasswordOnfocus(){
	        this.passwordKeyboard = false;
	        this.confirmPasswordKeyboard = true;
	        this.passwordPanelTop = 30;
	    },
	    confirmPasswordOnDelete() {
	      this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
	    },
	    confirmPasswordOnInput(key) {
	        this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
	    },
	    cancelChangePassword(){
	      this.password = '';
	      this.confirmPassword = '';
	      this.passwordPanelTop = 50;
	      this.showPasswordPanel = false;
	    },
	    checkPassword(){
        	if(this.alreadySetUp){
        		return true;
        	}
        	if(this.password.length < 6){
        		Toast.fail("请设置六位支付密码");
        		return false;
        	}

        	if(this.password != this.confirmPassword){
        		Toast.fail("两次输入的密码不一致");
        		return false;
        	}
        	return true;
        },
        sureToRecharge(){
            if(this.checkPassword()){
                this.submitEvent()
            }
        },
	    /***   修改密码  end   ***/
        aaaa(){
            this.checked = true
        },
        cccc(){
            Dialog.confirm({
            title: '活动协议',
            width:'90%',
            showCancelButton:false,
            messageAlign:'center',
            confirmButtonColor:'#ee0a24',
            message: `友好协商，自愿购买`,
            }).then(() => {
               this.checked = true
            }).catch(() => {
                // on cancel
            });
        },
    }
}
</script>
<style lang="less" scoped>
.changePasswordPanel-balanceRecharge{
    padding: 10px;
    .icon-cross{
        position: absolute; 
        right: 10px;
        font-size: 16px;
    }
    p{
        margin: 10px 16px 0 16px;
        line-height: 30px;
    }

    .confirmChangePassword{
        display:flex;
        justify-content: flex-end;
        margin-top: 20px;
        .confirmChangePasswordBtn{
            width: 80px;
            margin: 0 15px;
        }
    }
}
.body{
    background: #ff5f3d;
    width:100%;
    // height:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    .t-img{
        width:100%;
        height: 310px;
        img{
            width:100%;
            height:100%;
            display: inline-block;
            overflow: hidden;
            position: relative;
        }
    }
    .huodong{
        margin-top: -25px;
        padding:0 10px;
        width:calc(100% - 20px);
        z-index: 2;
        .hd-flex{
            padding: 0 11px 16px;
            border-radius: 8px;
            background: #fff;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            margin-bottom: 22px;
            .huodongTitle{
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    width: 198px;
                    align-self: center;
                    height: 38px;
                    display: inline-block;
                    overflow: hidden;
                    position: relative;
                }
                .huodongTitleText{
                    position: absolute;
                    top: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 80%;
                    color: #fff;
                }
            }
            .title{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                box-sizing: border-box;
                padding: 0 5px;
                border-bottom: 0.5px solid rgba(0,0,0,.2);
                margin-top: 5px;
                line-height: 44px;
                .text1{
                    font-size: 17px;
                    font-weight: 700;
                    color: #333;
                }
            }
            .text3{
                font-size: 12px;
                color: #333;
                margin-top: 12px;
                line-height: 20px;
            }
            .s-img{
                width: 100%;
                margin-top: 10px;
                height: 54px;
                img{
                    width:100%;
                    height:100%;
                    display: inline-block;
                    overflow: hidden;
                    position: relative;
                }
            }
            .text4{
                font-size: 10px;
                color: #8b5706;
                margin-top: 18px;
                line-height: 20px;
            }
        }
        .checkbox-info{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
            span{
                font-size: 14px;
                display: inline-block;
                padding-left:6px;
            }
            ::v-deep .van-checkbox__icon {
                .van-icon{
                    font-size: 12px;
                    width: 15px;
                    height: 15px;
                    line-height: 15px;
                }
                padding-top: 6px;
            }
        }
        .huodongBtn{
            position: relative;
            align-self: center;
            display: flex;
            justify-content: center;
            margin-bottom: 35px;
            height: 75px;
            background: url('../../assets/hd/btn.6f7529d1.png') no-repeat center;
            background-size: 100%;
            align-items: center;
        }
    }
}
</style>